export default __webpack_public_path__ + "static/media/img_stickman_animation.0b887aac.webp";